"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryAssignmentFilter = void 0;
const cache_1 = require("../util/cache");
const assignment_service_1 = require("./assignment-service");
class InMemoryAssignmentFilter {
    constructor(size, ttlMillis = assignment_service_1.DAY_MILLIS) {
        this.cache = new cache_1.Cache(size, ttlMillis);
    }
    shouldTrack(assignment) {
        const canonicalAssignment = assignment.canonicalize();
        const track = this.cache.get(canonicalAssignment) == undefined;
        if (track) {
            this.cache.put(canonicalAssignment, 0);
        }
        return track;
    }
}
exports.InMemoryAssignmentFilter = InMemoryAssignmentFilter;
